export class TreeUtils {
  // Given the rootNode of a tree, returns the list of leafIds as well as a maps of idToNode and codeToNode
  static parseTree = (rootNode) => {
    const leafIds = [];
    const idToNode = {};
    const codeToNode = {};

    const traverseNodes = (node) => {
      idToNode[node.id] = node;
      codeToNode[node.code] = node;
      if (node.children?.length > 0) {
        node.children.forEach((child) => {
          traverseNodes(child);
        });
      } else {
        leafIds.push(node.id);
      }
    };

    traverseNodes(rootNode);
    return { leafIds, idToNode, codeToNode };
  };

  // Reduces a tree selection to whichever of the selected or excluded ids is smaller, so that
  // filtering on everything sends an empty list rather than every id in the tree. The returned
  // `not` flag tells the server to read `ids` as the excluded set.
  static smallestIdFilter = (selectedIds, totalIds) => {
    const selected = selectedIds ?? [];
    const total = totalIds ?? [];

    if (selected.length <= total.length / 2) {
      return { ids: selected, not: false };
    }

    const selectedSet = new Set(selected);
    return { ids: total.filter((id) => !selectedSet.has(id)), not: true };
  };
}
